// routes/UserRoutes.js
import React from "react";
import { Routes,Route } from "react-router-dom";
import LoginPage from "../../pages/login/LoginPage";
import Layout from "../../component/ui/Layout";
// import ErrorBoundary from "../../components/errorBoundary/ErrorBoundary";
import Home from "../../pages/Home";
import Favorite from "../../pages/Favorite";
import Category from "../../pages/Category";
import AllVideo from "../../pages/AllVideo";
import Playlist from "../../pages/Playlist";
import AllPlaylist from "../../pages/AllPlaylist";

// import Movie from "../../pages/Movie";
// import MovieCollection from "../../pages/MovieCollection";
// import Show from "../../pages/Show";
// import Person from "../../pages/Person";
import Profile from "../../pages/Profile";
// import MoviesMain from "../../pages/MoviesMain";
// import MoviesByGenre from "../../pages/MoviesByGenre";
// import ShowsMain from "../../pages/ShowsMain";
// import ShowsByGenre from "../../pages/ShowsByGenre";
import SearchResults from "../../pages/SearchResults";

import ContinueWatching from "../../pages/ContinueWatching";
// import Sitemap from "../../pages/Sitemap";
// import AboutUs from "../../pages/AboutUs";
// import AppInfo from "../../pages/AppInfo";
// import ContactUs from "../../pages/ContactUs";
// import Privacy from "../../pages/Privacy";
// import TermsOfUse from "../../pages/TermsOfUse";
// import Success from "../../pages/Success";
// import ErrorForm from "../../pages/ErrorForm";
// import NotFound from "../../pages/NotFound";
import MovieDetailsPage from "../../pages/movieDetailsPage/MovieDetailsPage";

// import ProtectedRoute from "../../components/ProtectedRoute";
// import ErrorMedia from "../../components/ErrorMedia";

// import {
//   movieLoader,
//   movieCollectionLoader,
//   showLoader,
//   personLoader,
// } from "../../loaders";

const UserRoutes = () => {
  return (

    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="/" element={
        <Layout>
          <Home />
        </Layout>
      } />
      <Route path="search" element={
        <Layout>
          <SearchResults />
        </Layout>
      } />
      <Route path="videos/:id" element={
        <Layout>
          <MovieDetailsPage />
        </Layout>
      } />
      <Route path="videos/all/:id" element={
        <Layout>
          <AllVideo />
        </Layout>
      } />
      <Route path="continueWatching" element={
        <Layout>
          <ContinueWatching />
        </Layout>
      } />
      <Route path="favorites" element={
        <Layout>
          <Favorite />
        </Layout>
      } />
      <Route path="categoria" element={
        <Layout>
          <Category />
        </Layout>
      } />
      <Route path="playlist/:id" element={
        <Layout>
          <Playlist />
        </Layout>
      } />
        <Route path="playlist/all/:id/:title" element={
        <Layout>
          <AllPlaylist />
        </Layout>
      } />
      <Route path="profilo" element={
        <Layout>
          <Profile />
        </Layout>
      } />


    </Routes>
  );
};

export default UserRoutes;
